import React from 'react';
import { useSelector } from 'react-redux';
import { selectHasFirmSettingsAccess } from '../../../CommonSelectors/CommonAreaSelector';
import { useWidgetsQuery } from '../../api/useWidgetsQuery';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { Loading } from '../../../CommonComponents/OPL/Loading/Loading';
import { ErrorState } from '../../../CommonComponents/OPL/AsyncStates/ErrorState/ErrorState';
import { DesktopWidgetsEmpty } from './DesktopWidgets.empty';
import { EditWidgets } from './components/EditWidgets/EditWidgets';
import { Widgets } from './components/Widgets/Widgets';
import { TabSlug } from '../../types';

interface Props {
  tab: TabSlug;
}

export const DesktopWidgets = ({ tab }: Props) => {
  const { isLoading, isError, refetch, data, dataUpdatedAt: widgetsUpdatedAt } = useWidgetsQuery({
    tab,
  });

  const isFirmLevelUser = useSelector(selectHasFirmSettingsAccess);

  if (isLoading) {
    return (
      <Box display="flex" flexDirection="column" alignItems="center" mt={100}>
        <Loading />
      </Box>
    );
  }

  if (isError) {
    return (
      <Box display="flex" flexDirection="column" alignItems="center" mt={100}>
        <ErrorState onAction={refetch} />
      </Box>
    );
  }

  if (!data) {
    return null;
  }

  if (data.included.length === 0) {
    return <DesktopWidgetsEmpty tab={tab} widgets={data} isFirmLevelUser={isFirmLevelUser} />;
  }

  if (isFirmLevelUser) {
    return (
      <EditWidgets
        // Use the key to re-render the component and update its internal state
        key={`widgets-${widgetsUpdatedAt}`}
        tab={tab}
        widgets={data}
      />
    );
  }

  return <Widgets widgets={data} />;
};
